const animationEnterHideCircleLoader = () => {
  const loader = document.querySelector('.loader');

  loader.style.left = 0;

  const tl = gsap.timeline();

  tl.to(loader, {
    duration: 1,
    scaleX: 0.5, // squash the loader
    scaleY: 0.1, // squash the loader
    yPercent: 0, // move it down
    ease: 'Power4.inOut',
  });

  return tl;
};

export default animationEnterHideCircleLoader;
